import { DialogSurface, DialogBody } from "@fluentui/react-components";
import AssignmentInfo from "../../UserAssignments/components/AssignmentInfo";

export default function DeviceAssignmentDialog() {    
    return (
       <DialogSurface style={{top: "-20%"}}>
            <DialogBody style={{display: "flex", flexDirection: "column"}}>
                <AssignmentInfo />
            </DialogBody>
        </DialogSurface>
    );
}
